import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/wangdi/Developer/react/react-afterpay-checkout/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Button } from '../src/button';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "usage"
    }}>{`Usage`}</h1>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h3>
    <p>{`A very simple example.`}</p>
    <Playground __position={0} __code={'<Button token=\"123\" countryCode=\"AU\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Button token="123" countryCode="AU" mdxType="Button" />
    </Playground>
    <h3 {...{
      "id": "logo"
    }}>{`Logo`}</h3>
    <p>{`Display text logo, image logo or both.`}</p>
    <Playground __position={1} __code={'<Button token=\"123\" countryCode=\"AU\">\n  Buy now with\n</Button>\n<label> </label>\n<Button token=\"123\" countryCode=\"AU\" logo=\"image\">\n  Buy now with\n</Button>\n<label> </label>\n<Button token=\"123\" countryCode=\"AU\" logo=\"text\">\n  Buy now with\n</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Button token="123" countryCode="AU" mdxType="Button">Buy now with</Button><label> </label>
	<Button token="123" countryCode="AU" logo="image" mdxType="Button">Buy now with</Button><label> </label>
	<Button token="123" countryCode="AU" logo="text" mdxType="Button">Buy now with</Button>
    </Playground>
    <h3 {...{
      "id": "theme"
    }}>{`Theme`}</h3>
    <p>{`Different button styles. `}<inlineCode parentName="p">{`white-black`}</inlineCode>{` is the default style.`}</p>
    <Playground __position={2} __code={'<Button token=\"123\" countryCode=\"AU\" theme=\"white-black\">\n  Shop now with\n</Button>\n<label> </label>\n<Button token=\"123\" countryCode=\"AU\" theme=\"mint-black\">\n  Shop now with\n</Button>\n<label> </label>\n<Button token=\"123\" countryCode=\"AU\" theme=\"black-mint\">\n  Shop now with\n</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Button token="123" countryCode="AU" theme="white-black" mdxType="Button">Shop now with</Button><label> </label>
	<Button token="123" countryCode="AU" theme="mint-black" mdxType="Button">Shop now with</Button><label> </label>
	<Button token="123" countryCode="AU" theme="black-mint" mdxType="Button">Shop now with</Button>
    </Playground>
    <h3 {...{
      "id": "clearpay"
    }}>{`Clearpay`}</h3>
    <p>{`When the `}<inlineCode parentName="p">{`countryCode='GB'`}</inlineCode>{`, the logo will be Clearpay.`}</p>
    <Playground __position={3} __code={'<Button token=\"123\" countryCode=\"GB\">\n  Shop with\n</Button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Button,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Button token="123" countryCode="GB" mdxType="Button">Shop with</Button>
    </Playground>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`token`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(required) checkout token to be used to complete payment.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`countryCode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(required) country code.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`behavior`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`method of launching the checkout page.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`enum: `}<inlineCode parentName="td">{`popup`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`redirect`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`popup`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`onComplete`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`callback when transaction is complete. `}<strong parentName="td">{`popup mode only`}</strong>{`.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(event: any) => void`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`logo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`determine how to display the logo.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`enum: `}<inlineCode parentName="td">{`image`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`text`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`all`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`all`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`theme`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`color of button's background and label.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`enum: `}<inlineCode parentName="td">{`white-black`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`black-mint`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`mint-black`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`white-black`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`className`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`classname of button wrapper.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`extra styles.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`React.CSSProperties`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      